module.exports = __webpack_public_path__ + "img/icon-indices-tematicos.5c14cf8f.svg";